<template>
  <AccessRestricted
    :title="title"
    :message="message"
    :eyebrow="resolvedEyebrow"
    :icon="resolvedIcon"
    :action-label="resolvedActionLabel"
    :action-href="resolvedActionHref"
    :show-secondary-action="showSecondaryAction"
    :secondary-action-label="secondaryActionLabel"
    :secondary-action-href="secondaryActionHref"
    :secondary-action-target="secondaryActionTarget"
  />
</template>

<script>
import AccessRestricted from "@/shared/components/common/AccessRestricted.vue";

export default {
  name: 'ToolAccessState',
  components: {
    AccessRestricted
  },
  props: {
    title: {
      type: String,
      default: 'Acceso no incluido'
    },
    message: {
      type: String,
      default: 'Tu plan actual no incluye acceso a esta herramienta.'
    },
    anonymous: {
      type: Boolean,
      default: false
    },
    actionLabel: {
      type: String,
      default: ''
    },
    actionHref: {
      type: String,
      default: ''
    },
    showSecondaryAction: {
      type: Boolean,
      default: false
    },
    secondaryActionLabel: {
      type: String,
      default: ''
    },
    secondaryActionHref: {
      type: String,
      default: ''
    },
    secondaryActionTarget: {
      type: String,
      default: '_self'
    }
  },
  computed: {
    resolvedEyebrow() {
      return this.anonymous ? 'Sesión necesaria' : 'Herramienta bloqueada';
    },
    resolvedIcon() {
      return this.anonymous ? 'login' : 'lock';
    },
    resolvedActionLabel() {
      if (this.actionLabel) {
        return this.actionLabel;
      }
      return this.anonymous ? 'Iniciar sesión' : 'Ver planes';
    },
    resolvedActionHref() {
      if (this.actionHref) {
        return this.actionHref;
      }
      return this.anonymous ? '/user/login' : '/app/store';
    }
  }
}
</script>
